import { FileText } from "lucide-react";

const URL_RE = /(https?:\/\/[^\s<>"]+)/g;

const linkify = (text) =>
  text.split(URL_RE).map((part, i) => {
    if (i % 2 === 0) return part;
    const trail = part.match(/[.,;:!?)\]]+$/)?.[0] || "";
    const href = trail ? part.slice(0, -trail.length) : part;
    return (
      <span key={i}>
        <a href={href} target="_blank" rel="noopener noreferrer" className="lz-link" data-testid="live-message-link">{href}</a>
        {trail}
      </span>
    );
  });

export const LiveContent = ({ m, chat, sender }) => {
  const f = m.file;
  const url = f && chat ? chat.fileUrl(f) : "";
  return (
    <>
      {sender && <p className="lz-sender">{sender}</p>}
      {f && (String(f.type || "").startsWith("image/") ? (
        <a href={url} target="_blank" rel="noopener noreferrer" data-testid={`live-file-${m.id}`}>
          <img src={url} alt={f.name || "imagem"} className="lz-file-img" />
        </a>
      ) : (
        <a href={url} target="_blank" rel="noopener noreferrer" className="lz-file" data-testid={`live-file-${m.id}`}>
          <FileText size={20} className="shrink-0 text-[#D4FF3A]" />
          <span className="truncate">{f.name || "arquivo"}</span>
        </a>
      ))}
      {m.text && (
        <p className="lz-text whitespace-pre-wrap break-words">
          {m.from === "staff" || m.from === "ai" ? linkify(m.text) : m.text}
        </p>
      )}
    </>
  );
};
